/**
 * Becareful, you MUST use this functions by binding 'this' and after execute it
 * Exemple: configService.getGlobalConfigFile.bind(this)()
 * This permit to pass the context 'this' with $store.
 */
import axios from 'axios';

/**
 * Retrieve affiliate config file
 * @returns {Promise}
 */
const getAffiliateConfigFile = function (mutations) {
  return new Promise((resolve, reject) => {
    if (this.$store.getters.affiliateConfig !== null) {
      return resolve();
    }

    axios.get(window.location.origin + '/config.json').then(response => {
      if (!response || !response.data) {
        const message = 'Unable to read affiliate config file';
        this.$log.error(message, response);
        reject(message);
        return;
      }

      this.$store.commit(mutations.SET_AFFILIATE_CONFIG, response.data);
      resolve();
    }, error => {
      const message = `Unable to retrieve affiliate config file due to: ${error.message}`;
      this.$log.error(message, error);
      reject(message);
    });
  });
};


/**
 * Retrieve journey config file
 * @returns {Promise}
 */
const getJourneyConfigFile = function (mutations) {
  const patternStatics = /\/static\/[a-z]+\/[a-zA-Z-_]+\.html/;

  if (patternStatics.test(window.location.pathname)) {
    this.$store.commit(mutations.SET_JOURNEY_CONFIG, {});
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    if (this.$store.getters.journeyConfig !== null) {
      return resolve();
    }

    axios.get('../config.json').then(response => {
      if (!response || !response.data) {
        const message = 'Unable to read journey config file';
        this.$log.error(message, response);
        reject(message);
        return;
      }

      this.$store.commit(mutations.SET_JOURNEY_CONFIG, response.data);
      resolve();
    }, error => {
      const message = 'Unable to retrieve journey config file';
      this.$log.error(message, error);
      reject(message);
    });
  });
};


/**
 * Retrieve local config file
 * @returns {Promise}
 */
const getLocalConfigFile = function (mutations) {
  const patternStatics = /\/static\/[a-z]+\/[a-zA-Z-_]+\.html/;

  if (patternStatics.test(window.location.pathname)) {
    window.VANGUARD_LOCAL_CONFIG = {};
    this.$store.commit(mutations.SET_LOCAL_CONFIG, {});
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    if (this.$store.getters.localConfig !== null) {
      return resolve();
    }

    axios.get('./config.json').then(response => {
      if (!response || !response.data) {
        const message = 'Unable to read local config file';
        this.$log.error(message, response);
        reject(message);
        return;
      }

      window.VANGUARD_LOCAL_CONFIG = response.data;
      this.$store.commit(mutations.SET_LOCAL_CONFIG, response.data);
      resolve();
    }, error => {
      const message = 'Unable to retrieve local config file';
      this.$log.error(message, error);
      reject(message);
    });
  });
};


const configs = {
  getAffiliateConfigFile,
  getJourneyConfigFile,
  getLocalConfigFile
};

export default configs;



// WEBPACK FOOTER //
// ./src/common/services/configs.js